import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes, RouterNavigationBridge } from '@/router';
import '@/index.css';

const base = __BASE_PATH__;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={base}>
      <RouterNavigationBridge />
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>,
);